import React, {useState, useEffect} from 'react'
import { Container, List, ListItem, ListItemAvatar, Avatar, ListItemText, 
    Typography,  Grid, Paper, IconButton, TextField,  InputAdornment, Button } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import {animateScroll} from 'react-scroll'
import SendIcon from '@material-ui/icons/Send'
import firebase from '../Services/firebase'
import { v4 as uuidv4 } from 'uuid'
import userService from '../Services/user'
import Chats from './Chats'
import Users from './Users'
import { useHistory } from 'react-router-dom'

const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
    },
    paper: {
      padding: theme.spacing(2),
      textAlign: 'center',
      color: theme.palette.text.secondary,
    },
}))


function ActualRoom(props) {
    const classes = useStyles()
    const history = useHistory()

    const [newMessage, setNewMessage] = useState("")
    const [room, setRoom] = useState({})
 //   const [users, setUsers]= useState([])
    const [you, setYou] = useState({})
    const [myName, setMyName] = useState("")
    const [roomAdminId, setRoomAdminId] = useState("")


    useEffect(()=>{
        var localRoom = props.room
        if(localRoom){
            setRoomAdminId(localRoom.admin.userUID)
            setRoom(localRoom)

            if(userService.isAuthenticated){
                var user = userService.getCurrentUser()
                setYou(user)
                setMyName(user.name)
            

                const connectedRef = firebase.database().ref('.info/connected')
                var usersRef = firebase.database().ref("/rooms/" + localRoom.roomName + "/people")
                connectedRef.on('value', function (snap) {
                    if (snap.val() === true) {
                        const con = usersRef.child(user.userUID)
                        con.onDisconnect().update({status: "Offline"})
                        con.update({status: "Online"})
                    }
                });
            }
        } 
    }, [props.room])

    useEffect(()=>{
        
    },[])

    const scrollToBottom = ()=>{
        animateScroll.scrollToBottom({
            containerId : 'options-holder'
        })
    }

    const sendMessage = (e)=>{
        e.preventDefault();
        scrollToBottom()
        setNewMessage("")


        var messageRef = firebase.database().ref("/chats/" + room.roomName)

        var newMessageObj = {
            userId: you.userUID,
            userName: you.name,
            message: newMessage,
            messageId: uuidv4(),
            sendingTime: Date.now()
        }
        messageRef.push(newMessageObj).then((data3)=>{
        })
    }

    const leaveRoom = ()=>{
        var userId = you.userUID
        // var userRef = firebase.database().ref("/rooms/" + room.roomName +"/people/" + userId)
        // userRef.remove()
        // .then((data)=>{
        //     userService.disconnect()
        //     console.log(data)
        //     setIsLeaving(false)
        //     console.log("User Removed")
        //     history.push('/')
        // })
        var usersRef = firebase.database().ref("/rooms/" + room.roomName + "/people")
        const con = usersRef.child(userId)
        userService.disconnect()
        history.push('/')
        con.update({status: "Offline"})
    }

    return (
        <Container style={{paddingTop:'15px'}} maxWidth="lg">
            <div className={classes.root}>
                <Grid container spacing={3}>
                
                <Grid item xs={12} sm={8}>
                    <Paper style={{backgroundColor:'#fff', padding:'5px', marginBottom:'-2px'}}>
                       
                        <div style={{display: 'flex', justifyContent:'space-between', alignItems:'center', margin: '5px 10px 7px 10px'}}>
                            <Typography>Room: {room.roomName}</Typography>
                            <Button style={{textTransform: 'none'}} variant="outlined" color="secondary" onClick={leaveRoom}>Leave</Button>
                        </div>
                    </Paper>

                    <Chats roomName={room.roomName} scrollToBottom={scrollToBottom} userId={you.userUID}/>   
                   

                    <Paper>
                        <div>
                            <form onSubmit={sendMessage}>
                                <TextField
                                    required
                                    id="outlined-required"
                                    variant="outlined"
                                    fullWidth
                                    value={newMessage}
                                    onChange={(e)=>{setNewMessage(e.target.value)}}
                                    InputProps={{ 
                                        endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton type="submit"
                                            aria-label="Send Message"
                                            >
                                            <SendIcon />
                                            </IconButton>
                                        </InputAdornment>
                                        ),
                                        startAdornment: (<InputAdornment position="start">
                                            <Typography variant="subtitle2" style={{margin: '-8px', color:'purple'}}>{myName} : &nbsp; </Typography>
                                        </InputAdornment>)
                                    }}
                                />
                            </form>
                        </div>
                        
                    </Paper>
                </Grid>
   
                <Grid item xs={12} sm={4}>
                    <Paper className={classes.paper}>
                        {/* <div>
                            <Typography>Users</Typography>
                        </div>
                        <div>
                            <List>
                                    {users.map((user, i)=>(
                                        <ListItem key={i}>
                                            <ListItemIcon>
                                                <Avatar style={{width: '27px', height:'27px'}}>R</Avatar>
                                            </ListItemIcon>
                                            <ListItemText 
                                                id={"user-id"+i} 
                                                primary={ucFirstJS(user.name)} />
                                            
                                      </ListItem>
                                    ))} 
                            </List>  
                        </div> */}

                        <Users roomName={room.roomName} userId={you.userUID} adminId={roomAdminId}/>
                    </Paper>
                </Grid>
            
                </Grid>
            </div>
        </Container>
    )
}

export default ActualRoom
